import { createStore } from 'vuex'
import getters from './getters'
import tagsView from './tagsView'
import permissionSupplier from './modules/permissionSupplier'
import app from './modules/app'
import user from './modules/user'
import dict from './modules/dict'
import category from './modules/category'
// 本地存储解决刷新数据小时问题
import createPersistedState from "vuex-persistedstate"

const store = createStore({
	modules: {
		app,
		tagsView,
		permissionSupplier,
		user,
		dict,
		category
	},
	getters,
	plugins: [
		createPersistedState({
			// 也可以是sessionstorage
			storage: window.localStorage,
			// tagsView: tagsView,
			paths: ['tagsView', 'app', 'permissionSupplier', 'user', 'dict']
		})
	]
})
export default store;
